// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Cn = require("re-classnames/src/Cn.bs.js");
var Css = require("bs-css-dom/src/Css.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Formality = require("re-formality/src/Formality.bs.js");
var Belt_Float = require("bs-platform/lib/js/belt_Float.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Webapi__Dom__Element = require("bs-webapi/src/Webapi/Webapi__Dom/Webapi__Dom__Element.js");
var Formality__ReactUpdate = require("re-formality/src/Formality__ReactUpdate.bs.js");
var Graph$BlossomPlayground = require("./Graph.bs.js");

var validators_name = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param) {
      var name = Graph$BlossomPlayground.Vertex.make(param.name);
      if (name === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Name cannot be blank."
              };
      }
      var name$1 = Caml_option.valFromOption(name);
      if (Graph$BlossomPlayground.Vertex.eq(name$1, param.oldName) || !Curry._2(Graph$BlossomPlayground.Vertex.$$Set.has, param.existingNames, name$1)) {
        return {
                TAG: /* Ok */0,
                _0: name$1
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Name \"" + (Graph$BlossomPlayground.Vertex.toString(name$1) + "\" is already taken. Delete that vertex first.")
              };
      }
    })
};

var validators = {
  existingNames: undefined,
  oldName: undefined,
  delete: undefined,
  name: validators_name
};

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            existingNames: /* Pristine */0,
            oldName: /* Pristine */0,
            delete: /* Pristine */0,
            name: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.existingNames
  };
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.oldName
  };
  var match_0$2 = {
    TAG: /* Ok */0,
    _0: input.delete
  };
  var match = fieldsStatuses.name;
  var match_0$3 = match ? match._0 : Curry._1(validators.name.validate, input);
  var existingNamesResult = match_0;
  var existingNamesResult$1;
  if (existingNamesResult.TAG) {
    existingNamesResult$1 = existingNamesResult;
  } else {
    var oldNameResult = match_0$1;
    if (oldNameResult.TAG) {
      existingNamesResult$1 = existingNamesResult;
    } else {
      var deleteResult = match_0$2;
      if (deleteResult.TAG) {
        existingNamesResult$1 = existingNamesResult;
      } else {
        var nameResult = match_0$3;
        if (!nameResult.TAG) {
          return {
                  TAG: /* Valid */0,
                  output: {
                    name: nameResult._0,
                    delete: deleteResult._0,
                    oldName: oldNameResult._0,
                    existingNames: existingNamesResult._0
                  },
                  fieldsStatuses: {
                    existingNames: /* Dirty */{
                      _0: existingNamesResult,
                      _1: /* Hidden */1
                    },
                    oldName: /* Dirty */{
                      _0: oldNameResult,
                      _1: /* Hidden */1
                    },
                    delete: /* Dirty */{
                      _0: deleteResult,
                      _1: /* Hidden */1
                    },
                    name: /* Dirty */{
                      _0: nameResult,
                      _1: /* Shown */0
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        existingNamesResult$1 = existingNamesResult;
      }
    }
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            existingNames: /* Dirty */{
              _0: existingNamesResult$1,
              _1: /* Hidden */1
            },
            oldName: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            },
            delete: /* Dirty */{
              _0: match_0$2,
              _1: /* Hidden */1
            },
            name: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurNameField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.name, validators_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  existingNames: init.existingNames,
                                  oldName: init.oldName,
                                  delete: init.delete,
                                  name: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDeleteField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.delete, state.fieldsStatuses.delete, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  existingNames: init.existingNames,
                                  oldName: init.oldName,
                                  delete: status,
                                  name: init.name
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurOldNameField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.oldName, state.fieldsStatuses.oldName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  existingNames: init.existingNames,
                                  oldName: status,
                                  delete: init.delete,
                                  name: init.name
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurExistingNamesField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.existingNames, state.fieldsStatuses.existingNames, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  existingNames: status,
                                  oldName: init.oldName,
                                  delete: init.delete,
                                  name: init.name
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */4 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && !match.TAG) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */4,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */5,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */7);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */6);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */5 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */6 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (!match$3.TAG) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */7 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateNameField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.name, state.submissionStatus, validators_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            existingNames: init.existingNames,
                                            oldName: init.oldName,
                                            delete: init.delete,
                                            name: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDeleteField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.delete, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            existingNames: init.existingNames,
                                            oldName: init.oldName,
                                            delete: status,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateOldNameField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.oldName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            existingNames: init.existingNames,
                                            oldName: status,
                                            delete: init.delete,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateExistingNamesField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.existingNames, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            existingNames: status,
                                            oldName: init.oldName,
                                            delete: init.delete,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */4 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                existingNames: /* Pristine */0,
                                oldName: /* Pristine */0,
                                delete: /* Pristine */0,
                                name: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                existingNames: /* Pristine */0,
                                oldName: /* Pristine */0,
                                delete: /* Pristine */0,
                                name: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */5 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */6 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG ? false : true;
  return {
          updateName: (function (nextInputFn, $$event) {
              var target = $$event.target;
              return Curry._1(dispatch, {
                          TAG: /* UpdateNameField */0,
                          _0: Curry._1(nextInputFn, target)
                        });
            }),
          updateDelete: (function (nextInputFn, $$event) {
              var target = $$event.target;
              return Curry._1(dispatch, {
                          TAG: /* UpdateDeleteField */1,
                          _0: Curry._1(nextInputFn, target)
                        });
            }),
          updateOldName: (function (nextInputFn, $$event) {
              var target = $$event.target;
              return Curry._1(dispatch, {
                          TAG: /* UpdateOldNameField */2,
                          _0: Curry._1(nextInputFn, target)
                        });
            }),
          updateExistingNames: (function (nextInputFn, $$event) {
              var target = $$event.target;
              return Curry._1(dispatch, {
                          TAG: /* UpdateExistingNamesField */3,
                          _0: Curry._1(nextInputFn, target)
                        });
            }),
          blurName: (function (_event) {
              return Curry._1(dispatch, /* BlurNameField */0);
            }),
          blurDelete: (function (_event) {
              return Curry._1(dispatch, /* BlurDeleteField */1);
            }),
          blurOldName: (function (_event) {
              return Curry._1(dispatch, /* BlurOldNameField */2);
            }),
          blurExistingNames: (function (_event) {
              return Curry._1(dispatch, /* BlurExistingNamesField */3);
            }),
          nameResult: Formality.exposeFieldResult(state.fieldsStatuses.name),
          deleteResult: Formality.exposeFieldResult(state.fieldsStatuses.delete),
          oldNameResult: Formality.exposeFieldResult(state.fieldsStatuses.oldName),
          existingNamesResult: Formality.exposeFieldResult(state.fieldsStatuses.existingNames),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.existingNames || match.oldName || match.delete || match.name) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG) {
                return false;
              } else {
                return true;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */4);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */5);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */6);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */6,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */7);
            })
        };
}

var validators_weight = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return {
              TAG: /* Ok */0,
              _0: Belt_Option.getWithDefault(Belt_Float.fromString(param.weight), 0)
            };
    })
};

var validators$1 = {
  delete: undefined,
  weight: validators_weight
};

function initialState$1(input) {
  return {
          input: input,
          fieldsStatuses: {
            delete: /* Pristine */0,
            weight: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm$1(input, validators, fieldsStatuses) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.delete
  };
  var match = fieldsStatuses.weight;
  var match_0$1 = match ? match._0 : Curry._1(validators.weight.validate, input);
  var deleteResult = match_0;
  var deleteResult$1;
  if (deleteResult.TAG) {
    deleteResult$1 = deleteResult;
  } else {
    var weightResult = match_0$1;
    if (!weightResult.TAG) {
      return {
              TAG: /* Valid */0,
              output: {
                weight: weightResult._0,
                delete: deleteResult._0
              },
              fieldsStatuses: {
                delete: /* Dirty */{
                  _0: deleteResult,
                  _1: /* Hidden */1
                },
                weight: /* Dirty */{
                  _0: weightResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    deleteResult$1 = deleteResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            delete: /* Dirty */{
              _0: deleteResult$1,
              _1: /* Hidden */1
            },
            weight: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm$1(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState$1(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurWeightField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.weight, validators_weight, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  delete: init.delete,
                                  weight: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDeleteField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.delete, state.fieldsStatuses.delete, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  delete: status,
                                  weight: init.weight
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && !match.TAG) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm$1(state.input, validators$1, state.fieldsStatuses);
                  if (match$1.TAG) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (!match$3.TAG) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState$1(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateWeightField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.weight, state.submissionStatus, validators_weight, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            delete: init.delete,
                                            weight: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDeleteField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.delete, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            delete: status,
                                            weight: init.weight
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                delete: /* Pristine */0,
                                weight: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                delete: /* Pristine */0,
                                weight: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG ? false : true;
  return {
          updateWeight: (function (nextInputFn, $$event) {
              var target = $$event.target;
              return Curry._1(dispatch, {
                          TAG: /* UpdateWeightField */0,
                          _0: Curry._1(nextInputFn, target)
                        });
            }),
          updateDelete: (function (nextInputFn, $$event) {
              var target = $$event.target;
              return Curry._1(dispatch, {
                          TAG: /* UpdateDeleteField */1,
                          _0: Curry._1(nextInputFn, target)
                        });
            }),
          blurWeight: (function (_event) {
              return Curry._1(dispatch, /* BlurWeightField */0);
            }),
          blurDelete: (function (_event) {
              return Curry._1(dispatch, /* BlurDeleteField */1);
            }),
          weightResult: Formality.exposeFieldResult(state.fieldsStatuses.weight),
          deleteResult: Formality.exposeFieldResult(state.fieldsStatuses.delete),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.delete || match.weight) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm$1(state.input, validators$1, state.fieldsStatuses);
              if (match.TAG) {
                return false;
              } else {
                return true;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

function useAutoFocus(param) {
  var focused = React.useRef(null);
  React.useEffect((function () {
          Belt_Option.map(Belt_Option.flatMap(Caml_option.nullable_to_opt(focused.current), Webapi__Dom__Element.asHtmlElement), (function (prim) {
                  prim.focus();
                  
                }));
          
        }), [focused]);
  return focused;
}

function Forms$VertexEditor(Props) {
  var dispatch = Props.dispatch;
  var onSubmit = Props.onSubmit;
  var name = Props.name;
  var names = Props.names;
  var focused = useAutoFocus(undefined);
  var form = useForm({
        name: Graph$BlossomPlayground.Vertex.toString(name),
        delete: false,
        oldName: name,
        existingNames: names
      }, (function (param, form) {
          var name = param.name;
          if (param.delete) {
            dispatch({
                  TAG: /* RemoveVertex */3,
                  _0: name
                });
          } else {
            dispatch({
                  TAG: /* RenameVertex */4,
                  old: param.oldName,
                  new_: name
                });
          }
          Curry._1(onSubmit, undefined);
          Curry._1(form.notifyOnSuccess, undefined);
          return Curry._1(form.reset, undefined);
        }));
  var match = form.nameResult;
  var tmp;
  tmp = match !== undefined && match.TAG ? React.createElement("p", undefined, match._0) : null;
  return React.createElement("form", {
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  return Curry._1(form.submit, undefined);
                })
            }, React.createElement("label", {
                  className: "dialog__label"
                }, React.createElement("p", {
                      className: "font-small"
                    }, "Rename " + (Graph$BlossomPlayground.Vertex.toString(form.input.oldName) + ":")), React.createElement("input", {
                      ref: focused,
                      disabled: form.submitting,
                      size: 10,
                      type: "text",
                      value: form.input.name,
                      onBlur: form.blurName,
                      onChange: Curry._1(form.updateName, (function (target, input) {
                              return {
                                      name: target.value,
                                      delete: input.delete,
                                      oldName: input.oldName,
                                      existingNames: input.existingNames
                                    };
                            }))
                    })), React.createElement("p", undefined, React.createElement("label", {
                      className: "dialog__label"
                    }, React.createElement("span", {
                          className: "font-small"
                        }, "Delete " + (Graph$BlossomPlayground.Vertex.toString(name) + ": ")), React.createElement("input", {
                          checked: form.input.delete,
                          type: "checkbox",
                          onChange: Curry._1(form.updateDelete, (function (target, input) {
                                  return {
                                          name: input.name,
                                          delete: target.checked,
                                          oldName: input.oldName,
                                          existingNames: input.existingNames
                                        };
                                }))
                        }))), React.createElement("button", {
                  className: Cn.on("dialog__button-delete", form.input.delete),
                  disabled: form.submitting
                }, form.submitting ? "Submitting..." : (
                    form.input.delete ? "Delete" : "Submit"
                  )), tmp);
}

var VertexEditor = {
  make: Forms$VertexEditor
};

function Forms$VertexAdder(Props) {
  var dispatch = Props.dispatch;
  var onSubmit = Props.onSubmit;
  var names = Props.names;
  var focused = useAutoFocus(undefined);
  var form = useForm({
        name: "",
        delete: false,
        oldName: Graph$BlossomPlayground.Vertex.empty,
        existingNames: names
      }, (function (param, form) {
          dispatch({
                TAG: /* AddVertex */0,
                _0: param.name
              });
          Curry._1(onSubmit, undefined);
          Curry._1(form.notifyOnSuccess, undefined);
          return Curry._1(form.reset, undefined);
        }));
  var match = form.nameResult;
  var tmp;
  tmp = match !== undefined && match.TAG ? React.createElement("p", undefined, match._0) : null;
  return React.createElement("form", {
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  return Curry._1(form.submit, undefined);
                })
            }, React.createElement("label", {
                  className: "dialog__label"
                }, React.createElement("p", {
                      className: "font-small"
                    }, "Name vertex:"), React.createElement("input", {
                      ref: focused,
                      disabled: form.submitting,
                      size: 10,
                      type: "text",
                      value: form.input.name,
                      onBlur: form.blurName,
                      onChange: Curry._1(form.updateName, (function (target, input) {
                              return {
                                      name: target.value,
                                      delete: input.delete,
                                      oldName: input.oldName,
                                      existingNames: input.existingNames
                                    };
                            }))
                    })), " ", React.createElement("button", {
                  disabled: form.submitting
                }, form.submitting ? "Submitting..." : "Submit"), tmp);
}

var VertexAdder = {
  make: Forms$VertexAdder
};

function Forms$EdgeSetter(Props) {
  var dispatch = Props.dispatch;
  var onSubmit = Props.onSubmit;
  var i = Props.i;
  var j = Props.j;
  var w = Props.w;
  var weight = Belt_Option.getWithDefault(w, 0);
  var focused = useAutoFocus(undefined);
  var form = useForm$1({
        weight: String(weight),
        delete: false
      }, (function (param, form) {
          if (param.delete) {
            dispatch({
                  TAG: /* RemoveEdge */2,
                  _0: i,
                  _1: j
                });
          } else {
            dispatch({
                  TAG: /* SetEdge */1,
                  _0: i,
                  _1: j,
                  _2: param.weight
                });
          }
          Curry._1(form.notifyOnSuccess, undefined);
          Curry._1(form.reset, undefined);
          return Curry._1(onSubmit, undefined);
        }));
  var x = form.input.weight;
  var tmp = x === "" ? "0" : x;
  var match = form.weightResult;
  var tmp$1;
  tmp$1 = match !== undefined && match.TAG ? React.createElement("p", undefined, match._0) : null;
  return React.createElement("form", {
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  return Curry._1(form.submit, undefined);
                })
            }, React.createElement("label", undefined, React.createElement("p", undefined, "Set the weight for the edge betweeen ", React.createElement("strong", undefined, Graph$BlossomPlayground.Vertex.toString(i)), " and ", React.createElement("strong", undefined, Graph$BlossomPlayground.Vertex.toString(j)), "."), React.createElement("input", {
                      ref: focused,
                      className: "match-adder__weight",
                      style: Css.style({
                            hd: Css.width(Css.em(3.0)),
                            tl: /* [] */0
                          }),
                      disabled: form.submitting || form.input.delete,
                      type: "number",
                      value: tmp,
                      onChange: Curry._1(form.updateWeight, (function (target, input) {
                              return {
                                      weight: target.value,
                                      delete: input.delete
                                    };
                            }))
                    })), React.createElement("p", {
                  className: "font-small"
                }, React.createElement("label", {
                      className: "dialog__label"
                    }, "Remove ", React.createElement("input", {
                          checked: form.input.delete,
                          type: "checkbox",
                          onChange: Curry._1(form.updateDelete, (function (target, input) {
                                  return {
                                          weight: input.weight,
                                          delete: target.checked
                                        };
                                }))
                        }))), React.createElement("button", {
                  className: Cn.on("dialog__button-delete", form.input.delete),
                  disabled: form.submitting
                }, form.submitting ? "Submitting..." : (
                    form.input.delete ? "Delete" : "Submit"
                  )), tmp$1);
}

var EdgeSetter = {
  make: Forms$EdgeSetter
};

exports.VertexEditor = VertexEditor;
exports.VertexAdder = VertexAdder;
exports.EdgeSetter = EdgeSetter;
/* Css Not a pure module */
